export default __webpack_public_path__ + "static/media/1388.8275de71.png";